<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Posta"
    }
</script>

<style scoped>

</style>